import { render, staticRenderFns } from "./PointOrderItem.vue?vue&type=template&id=f68726a6&scoped=true&"
import script from "./PointOrderItem.vue?vue&type=script&lang=js&"
export * from "./PointOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./PointOrderItem.vue?vue&type=style&index=0&id=f68726a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68726a6",
  null
  
)

export default component.exports